import React from "react";
import className from "classnames/bind";
import styles from "../OrderInfoPage.module.scss";

const cx = className.bind(styles);

const SuccessModal = ({ orderSuccess }) => {
  if (!orderSuccess) return null;

  return (
    <div className={cx("success-overlay")}>
      <div className={cx("success-modal")}>
        <div className={cx("success-icon")}>
          <span role="img" aria-label="success checkmark">
            ✅
          </span>
        </div>

        <h2>Đặt hàng thành công!</h2>
        <p>Đơn hàng COD của bạn đã được tạo thành công.</p>
        <p>Đang chuyển hướng đến trang xác nhận...</p>
        <div className={cx("loading-dots")}>
          <span>.</span>
          <span>.</span>
          <span>.</span>
        </div>
      </div>
    </div>
  );
};

export default SuccessModal;
